export default __webpack_public_path__ + "static/google-reviews-0854c7940932f7bcf1d048acd56dfdb2.png";